import { Component, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormsModule, NgForm } from '@angular/forms';
import { MatDialogActions, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { Feature } from 'app/models/feature.models';
import { AuthService } from 'app/services/auth.service';
import { FeatureService } from 'app/services/feature.service';

import { FilterService } from 'app/services/filter.service';
import { makeControlDirty } from 'app/utils/form.utils';
import { StorageKeys } from 'app/constants/common.constants';
import { MatTab, MatTabGroup } from '@angular/material/tabs';
import { TimeTabComponent } from './time-tab/time-tab.component';
import { AreasTabComponent } from './areas-tab/areas-tab.component';
import { OffenceDescTabComponent } from './offence-desc-tab/offence-desc-tab.component';
import { VehiclesTabComponent } from './vehicles-tab/vehicles-tab.component';
import { DemographicsTabComponent } from './demographics-tab/demographics-tab.component';
import { StopDetailsTabComponent } from './stop-details-tab/stop-details-tab.component';
import { NgIf } from '@angular/common';
import { PersonnelTabComponent } from './personnel-tab/personnel-tab.component';
import { PersonalTabComponent } from './tabs/personal-tab/personal-tab.component';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-filter-dialog',
  templateUrl: './filter-dialog.component.html',
  styleUrls: ['./filter-dialog.component.scss'],
  imports: [
    FormsModule,
    MatDialogContent,
    MatTabGroup,
    MatTab,
    TimeTabComponent,
    AreasTabComponent,
    OffenceDescTabComponent,
    VehiclesTabComponent,
    DemographicsTabComponent,
    StopDetailsTabComponent,
    NgIf,
    PersonnelTabComponent,
    PersonalTabComponent,
    MatDialogActions,
    MatButton,
  ],
})
export class FilterDialogComponent implements OnInit {
  @ViewChild('filtersForm') form!: NgForm;

  // TODO: do we need the old "Personal" tab? We may want to remove it altogether
  isPersonalInfoEnabled = false;
  lastOpenedTabIndex = 0;
  savedTabIndex = 0;

  get isPersonnel(): boolean {
    return this.authService.isOperationsRoles;
  }

  constructor(
    private dialogRef: MatDialogRef<FilterDialogComponent>,
    private filterService: FilterService,
    private featureService: FeatureService,
    private authService: AuthService,
  ) {
    this.isPersonalInfoEnabled = featureService.isFeatureEnabled(Feature.PERSONAL_INFO);
  }

  ngOnInit() {
    this.initFilters();
    const savedIndex = sessionStorage.getItem(StorageKeys.LAST_OPENED_TAB_INDEX);
    this.savedTabIndex = savedIndex ? parseInt(savedIndex, 10) : 0;
    this.lastOpenedTabIndex = this.savedTabIndex;
  }

  onTabGroupSelectedIndexChanged(index: number) {
    sessionStorage.setItem(StorageKeys.LAST_OPENED_TAB_INDEX, index.toString());
  }

  close() {
    this.dialogRef.close();
  }

  reset() {
    this.form.reset();

    Object.values(this.form.controls).forEach((control: AbstractControl) => {
      makeControlDirty(control);
    });

    this.initFilters();
  }

  onSubmit(): void {
    this.filterService.applyFilters(this.form.value);
    this.close();
  }

  private initFilters() {
    if (!this.authService.isAdmin) {
      this.filterService.getDefaultValues().subscribe(({ departmentId }) => {
        this.form.control.patchValue({
          areaGroup: {
            departmentId,
          },
        });
      });
    }
  }
}
